import { useEnv } from '../../../context/env-context';
import { SyncLogStatusAlert } from '../../sync';

export function CustomerSyncStatusAlert() {
  const env = useEnv();

  //TODO: Remove this once env is definitively loaded
  // TODO: is env.platform actually the correct value we want to use?
  if (!env?.platform) return null;

  return (
    <SyncLogStatusAlert
      syncFor={{ integration: env.platform, dataType: 'customers' }}
      allowViewErrors={true}
    />
  );
}
